





















































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import UploadOSS from '@/components/upload/index.vue'
import AlbumsApi from '@/api/albums/list'

@Component({
  components: {
    UploadOSS
  }
})
export default class PictureList extends Vue {
  selectAll: boolean = false
  page = {
    totalCount: 0,
    currentPage: 1,
    skipCount: 0,
    maxResultCount: 30
  }
  albumsId = null
  imgList = []
  showAction = -1
  selectImgList = []
  showModal = false
  albumsList = []
  selectAlbumsId = null
  loadingBtn = false
  get dir() {
    return 'images/' + this.albumsId
  }

  mounted() {
    this.albumsId = this.$route.query['id']
    this.getImagesList()
    this.getAlbumsList()
  }
  get selectAllDisplayName() {
    return this.selectAll ? '取消全选' : '全选'
  }
  selectedToggle() {
    let value = !this.selectAll
    this.imgList.forEach(t => (t.active = value))
    this.selectImgList = JSON.parse(JSON.stringify(this.imgList))
    this.selectAll = !this.selectAll
  }
  changePage(e) {
    this.page.currentPage = e
    this.page.skipCount =
      this.page.currentPage <= 1
        ? 0
        : (this.page.currentPage - 1) * this.page.maxResultCount
    this.getImagesList()
  }
  pageSizeChange(e) {
    this.page.maxResultCount = e
    this.page.currentPage = 1
    this.getImagesList()
  }

  onMouseFn(index?) {
    this.showAction = index
  }
  /**
   * 删除选中的图片
   */
  deleteSelectedPicture() {
    if (this.selectImgList.length <= 0) {
      this.$Modal.error({
        title: '请先选择图片'
      })
    } else {
      let ids = this.selectImgList.map(t => t.id)
      this.$Modal.confirm({
        title: '提示',
        content: `确认删除所选图片？`,
        onOk: () => {
          AlbumsApi.deleteImgs(ids).then(res => {
            this.$Notice.success({ desc: '删除成功' })
            this.getImagesList()
          })
        }
      })
    }
  }
  /**
   * 获取相册列表
   */
  getAlbumsList() {
    AlbumsApi.getAlbumsList(999, 0).then(res => {
      if (res.data) {
        this.albumsList = res.data.items || []
      }
    })
  }

  /**
   * 图片上传回调
   */
  uploadChange(event) {
    const urls = event.map(item=>{
      return item.url
    })
    const fileNames = event.map(item=>{
      return item.fileName
    })
    if (this.albumsId) {
      AlbumsApi.createImg(this.albumsId, urls, fileNames).then(res => {
        this.getImagesList()
      })
    }
  }

  /**
   * 选择图片
   */
  selectImgFn(params) {
    let vm = this
    let isHave = vm.selectImgList.some(item => item.id == params.id)

    if (!isHave) {
      params['active'] = true
      vm.selectImgList.push(params)
    } else {
      params['active'] = false
      vm.selectImgList.forEach((item, index) => {
        if (item.id == params.id) {
          vm.selectImgList.splice(index, 1)
        }
      })
    }

    this.selectAll = this.imgList.length === this.selectImgList.length
  }

  /**
   * 获取图片列表
   */
  getImagesList() {
    this.selectImgList = []
    if (this.albumsId) {
      let { maxResultCount, currentPage } = this.page
      AlbumsApi.getImagesList(this.albumsId, maxResultCount, currentPage, 'name').then(
        res => {
          if (res.data) {
            res.data.items.forEach(item => {
              item['editName'] = item.name
              item['active'] = false
            })
            this.imgList = res.data.items || []
            this.page.totalCount = res.data.totalCount
          }
        }
      )
    }
  }

  /**
   * 转移相册
   */
  showModalFn() {
    if (this.selectImgList.length == 0) {
      this.$Modal.error({
        title: '请先选择图片'
      })
      return false
    }

    this.showModal = true
  }

  transferAlbumFn() {
    if (!this.selectAlbumsId) {
      this.$Modal.error({
        title: '请选择相册'
      })
      return
    }
    if (this.selectAlbumsId == this.albumsId) {
      this.$Modal.error({
        title: '转移相册不能和当前相册相同'
      })
      return
    }
    this.loadingBtn = true
    let ids = this.selectImgList.map(item => {
      return item.id
    })
    AlbumsApi.transferAlbum(this.selectAlbumsId, ids)
      .then(res => {
        this.$Notice.success({
          desc: '转移成功'
        })
        this.loadingBtn = false
        this.showModal = false
        this.selectAlbumsId = null
        this.getImagesList()
      })
      .catch(err => {
        this.loadingBtn = false
      })
  }

  cancel() {
    this.showModal = false
    this.selectAlbumsId = null
    this.selectImgList = []
    this.imgList.forEach(item => {
      item['active'] = false
    })
  }

  /**
   * 更新图片名称
   */
  editImgNameFn(item) {
    if (!item.editName) {
      this.$Modal.error({
        title: '请输入图片名称'
      })
      return
    }
    AlbumsApi.updateImgName(item.id, item.editName).then(res => {
      this.$Notice.success({ desc: '修改成功' })
      this.getImagesList()
    })
  }

  /**
   * 删除图片
   */
  deleteImgFn(item) {
    this.$Modal.confirm({
      title: '提示',
      content: `确认删除所选图片？`,
      onOk: () => {
        AlbumsApi.deleteImg(item.id).then(res => {
          this.$Notice.success({ desc: '删除成功' })
          this.getImagesList()
        })
      }
    })
  }
}
